import { render, staticRenderFns } from "./ThemeSelector.vue?vue&type=template&id=5992d0aa&scoped=true&"
import script from "./ThemeSelector.vue?vue&type=script&setup=true&lang=js&"
export * from "./ThemeSelector.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ThemeSelector.vue?vue&type=style&index=0&id=5992d0aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5992d0aa",
  null
  
)

export default component.exports